import { Box, Text } from '@frontend/ui-library';
import cx from 'classnames';

import styles from './BillDetailHeader.module.css';

interface BillDetailHeaderProps {
  className?: string;
  amount: string;
  currency: string;
  isOffRamp: boolean;
}

export default function BillDetailHeader({
  className,
  amount,
  currency,
  isOffRamp,
}: BillDetailHeaderProps): JSX.Element {
  return (
    <Box className={cx(styles['base'], className)}>
      <Text size="miniscule-callout" color="royal-600">
        {isOffRamp ? 'Amount to off ramp' : 'Amount to pay'}
      </Text>
      <Text size="large" color="royal-500" weight="700" transform="uppercase">
        {amount} {currency}
      </Text>
    </Box>
  );
}
